import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import { Modal, ModalBody, Tooltip } from 'reactstrap';
import Spinner from '../common/spinner';
import PhoneNumber from "../common/input/PhoneNumber";
import SectionLoadingError from '../common/SectionLoadingError';
import * as Tools from "../../helpers/Tools";
import * as d from "../../reducers/domainReducer";
import { logUI } from '../../api/andyliticsApi';
import ConfirmationModal from "../common/ConfirmationModal";

class MobileNumberInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inInputMode: false,
            isValid: false,
            showStatus: false,
            showToolTip: false,
            mobileNumber: '',
            formattedMobileNumber: ''
        };
        this.createOrUpdatePhoneNumber = this.createOrUpdatePhoneNumber.bind(this);
        this.toggleInputMode = this.toggleInputMode.bind(this);
        this.getFormattedPhone = this.getFormattedPhone.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
    }

    componentDidMount() {
        if (this.props.userName) {
            this.props.getUserPhoneNumber(this.props.userName);
        }
        logUI("MBHWeb.UI.MobileNumberInfo.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps, prevState) {
        if ((this.props.addOrUpdateSuccess !== prevProps.addOrUpdateSuccess) && this.props.addOrUpdateSuccess) {
            this.props.getUserPhoneNumber(this.props.userName);
            this.setState({ inInputMode: false });
        }

        if (prevProps.userPhoneNumberData !== this.props.userPhoneNumberData && this.props.userPhoneNumberData !== 'None entered') {
            this.setState({ formattedMobileNumber: this.getFormattedPhone(this.props.userPhoneNumberData) });
        }
    }

    toggleTooltip() {
        this.setState(prevState => ({
            showToolTip: !prevState.showToolTip
        }));
    }

    createOrUpdatePhoneNumber() {
        if (this.state.isValid) {
            this.setState({ showStatus: true });
            let arrMobileNumber = this.state.mobileNumber.split('.');
            let areaCode = arrMobileNumber[0];
            let number = arrMobileNumber[1] + "" + arrMobileNumber[2];
            let newUser = false;
            let userId = this.props.userPhoneNumberData && this.props.userPhoneNumberData.PhoneNumber && this.props.userPhoneNumberData.UserId;
            if (!userId) {
                newUser = true;
                userId = this.props.userId;
            }
            this.props.addOrUpdateUserPhoneNUmber(this.props.userName, areaCode, number, userId, newUser);
            logUI("MBHWeb.Settings.UpdateUserPhone", new Date(), Tools.getURLPath());
        }
    }

    getFormattedPhone(phone) {
        if (phone && phone.PhoneNumber) {
            return `${phone.AreaCode}.${phone.PhoneNumber.substr(0, 3)}.${phone.PhoneNumber.substr(3)}`
        }
    }

    handleInputChange(event, isValid) {
        if (event) {
            const value = event.target.value;
            this.setState({ mobileNumber: value, isValid });
        }
    }

    toggleInputMode(cancel) {
        this.setState(prevState => ({
            inInputMode: !prevState.inInputMode
        }));
        this.setState(
            {
                mobileNumber: '',
                isValid: false,
                inInputMode: !cancel,
                showStatus: false
            });
    }

    render() {
        let { userPhoneNumberData, statusMessage, getPhoneNumberError, getPhoneNumbererrorText, getPhoneNumberWaiting, IsUpdateEror, isProxyUser } = this.props;
        const { inInputMode, mobileNumber, isValid, showStatus, formattedMobileNumber } = this.state;
        const serviceWaiting = (getPhoneNumberWaiting === true || getPhoneNumberWaiting === undefined) ? true : false;
        if (isProxyUser) {
            return "";
        }
        return (

            <div className="row">
                <div className="col-12 list-item-col not-linked">
                    <div className="row align-items-end">
                        <div className="col-12 col-sm-6 col-md-3">
                            <div className="list-item-col__label">Mobile <div className="list-item-col__label--phone">Phone <span className="icon-info" id='lbl-phoneNumber' /></div>   <Tooltip placement="top" isOpen={this.state.showToolTip} autohide={false} target="lbl-phoneNumber" toggle={this.toggleTooltip}>Used for prescription notifications </Tooltip></div>
                        </div>
                        <div className="col-12 col-sm-6 text-left text-sm-right text-md-left">
                            {serviceWaiting ?
                                <div className="spinner">
                                    <div className="bounce1" />
                                    <div className="bounce2" />
                                    <div className="bounce3" />
                                </div> :
                                userPhoneNumberData ?
                                    <div className="list-item-col__info">{formattedMobileNumber ? formattedMobileNumber : 'None entered'}</div>
                                    : getPhoneNumberError ? <div className="unable-display">Unable to display</div> : null
                            }
                        </div>
                        <div className="col-12 col-md-3 text-sm-right">
                            <div className="list-item-col__action">
                                {inInputMode ?
                                    <React.Fragment>
                                        {isValid ?
                                            <div className="list-item-col__action--save" onClick={this.createOrUpdatePhoneNumber}>Save</div> :
                                            <div className="list-item-col__action--save disabled-style">Save</div>}
                                        <div className="list-item-col__action--cancel" onClick={() => this.toggleInputMode(true)}>Cancel</div>
                                    </React.Fragment>
                                    :
                                    <div className="list-item-col__action--save" onClick={() => this.toggleInputMode(false)}>Edit</div>
                                }
                            </div>
                        </div>
                    </div>
                    {inInputMode && <div className="row edit-mode">
                        <div className="col-12 form-group">
                            <PhoneNumber name="PhoneNumber" placeholder="Mobile Phone Number"
                                onChange={(e, isValid) => this.handleInputChange(e, isValid)}
                                value={mobileNumber} ref="PhoneNumber" required
                                tooltipID="rxPhoneNumber" tooltipMsg="The phone number must match what your pharmacy has on file." />
                        </div>
                    </div>}
                    <div className="row align-items-end">
                        <div className="col-12">
                            {showStatus && <div className={IsUpdateEror ? "error-msg" : "success-msg"}>{statusMessage}</div>}
                        </div>
                    </div>
                </div>
                <ConfirmationModal when={inInputMode && mobileNumber !== ''} />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        userName: state.domain.un,
        userId: state.domain.ui,
        getPhoneNumberWaiting: state.header.getPhoneNumberWaiting,
        getPhoneNumberError: state.header.getPhoneNumberError,
        userPhoneNumberData: state.header.getUserPhoneNumberResponse,
        statusMessage: state.header.statusMessage,
        getPhoneNumbererrorText: state.header.getPhoneNumbererrorText,
        addOrUpdateSuccess: state.header.addOrUpdateSuccess,
        IsUpdateEror: state.header.IsUpdateEror,
        isProxyUser: state.domain.ip
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUserPhoneNumber: (userName) => {
            dispatch({ type: types.GET_USER_PHONE_NUMBER_START, userName: userName });
        },
        addOrUpdateUserPhoneNUmber: (userName, areaCode, phoneNumber, userId, newUser) => {
            dispatch({ type: types.ADD_OR_UPDATE_USER_PHONE_NUMBER_START, userName: userName, AreaCode: areaCode, PhoneNumber: phoneNumber, userId: userId, newUser });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileNumberInfo);